import NewCRMPagination from './NewCRMPagination';

export default NewCRMPagination;
